<template>
  <Modal
    v-model="_value"
    width="500"
    title='锐明触发报警行为'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onSendDriverCardParams">

    <Form :label-width="110">
      <FormItem prop="alarm" label="触发报警行为">
        <Select v-model="alarm" style="width: 220px;">
          <Option v-for="item in alarmOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="driverName" label="密码">
<!--        <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>-->
<!--        <Button type="primary" @click="posswordTwo">密码2</Button>-->
        <Input style="width: 220px;" v-model="setDriverCardParams.possword" placeholder="请输入密码">
        </Input>
        <br>
        <span style="color: red;">下列密码自动下发：admin、JC336699、（空白）、807315</span>
      </FormItem>
    </Form>
    <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
    <Button type="primary" @click="onSendDriverCardParams">发送</Button>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'rmsettriggeralarmmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    businessUserId: null
  },
  data () {
    return {
      setDriverCardParams: {
        possword: 'admin',
      },

      // 报警行为选项
      alarm: null,
      alarmOptions: [
        { name: '闭眼疲劳', value: 0 },
        // { name: '打电话', value: 2 },
        // { name: '抽烟', value: 3 },
        // { name: '分心驾驶', value: 4 },
        { name: '打哈欠', value: 10 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'ShortMessageServ_Send'
    ]),

    SendCommand (content) {
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onSendDriverCardParams () {
      // let content = '99admin,admin,SAAS56,'+this.alarm+'!'
      //
      // store.dispatch('NetCommandServ_SendCommand', {
      //   params: { id: this._initValue, content: content , urgent: false }
      // }).then(() => {
      //   this.$Message.success('发送成功')
      // }).catch(err => {
      //   this.$Message.error(err)
      // })

      this.SendCommand('99admin,' + this.setDriverCardParams.possword + ',SAAS56,' + this.alarm + '!')

      setTimeout(() => {
          this.SendCommand('99admin,admin,SAAS56,' + this.alarm + '!')
        }
        , 1000)

      setTimeout(() => {
        this.SendCommand('99admin,JC336699,SAAS56,' + this.alarm + '!')
      }
        , 2000)

      setTimeout(() => {
        this.SendCommand('99admin,,SAAS56,' + this.alarm + '!')
      }
        , 3000)

      setTimeout(() => {
          this.SendCommand('99admin,870315,SAAS56,' + this.alarm + '!')
        }
        , 4000)

      setTimeout(() => {
          this.SendCommand('99admin,JcBOZSJCB0,SAAS56,' + this.alarm + '!')
        }
        , 5000)
    },
    onCleanDriverCardParams () {
      this.alarm = null
    },
    visibleChange (val) {
      if (val) {
        this.alarm = null
      }
    },
    possworsOne(){
      this.setDriverCardParams.possword = 'admin'
    },
    posswordTwo(){
      this.setDriverCardParams.possword = 'JC336699'
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _businessUserId: {
      get () {
        return this.businessUserId
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules,
        phoneNum: this.phoneNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
